module.exports = __webpack_public_path__ + "img/design@2x.b49429d.webp";